"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAmountPropertySelector = void 0;
var react_1 = require("react");
var property_1 = require("@promaster-sdk/property");
var use_amount_format_selector_1 = require("./use-amount-format-selector");
var use_amount_input_box_1 = require("./use-amount-input-box");
function useAmountPropertySelector(options) {
    var onValueChange = options.onValueChange, onFormatChanged = options.onFormatChanged, onFormatCleared = options.onFormatCleared, notNumericMessage = options.notNumericMessage, isRequiredMessage = options.isRequiredMessage, validationFilter = options.validationFilter, propertyValueSet = options.propertyValueSet, propertyName = options.propertyName, filterPrettyPrint = options.filterPrettyPrint, inputUnit = options.inputUnit, inputDecimalCount = options.inputDecimalCount, readOnly = options.readOnly, _a = options.debounceTime, debounceTime = _a === void 0 ? 350 : _a, unitsFormat = options.unitsFormat, units = options.units, _b = options.comparer, comparer = _b === void 0 ? property_1.PropertyValue.defaultComparer : _b;
    var value = property_1.PropertyValueSet.getAmount(propertyName, propertyValueSet);
    var errorMessage = getValidationMessage(propertyValueSet, value, validationFilter, filterPrettyPrint, comparer);
    var onValueChangeCallback = react_1.useCallback(function (newAmount) { return onValueChange(newAmount !== undefined ? property_1.PropertyValue.create("amount", newAmount) : undefined); }, [onValueChange]);
    var amountInputBox = use_amount_input_box_1.useAmountInputBox({
        value: value,
        inputUnit: inputUnit,
        inputDecimalCount: inputDecimalCount,
        notNumericMessage: notNumericMessage,
        isRequiredMessage: isRequiredMessage,
        readOnly: readOnly,
        debounceTime: debounceTime,
        errorMessage: errorMessage,
        onValueChange: onValueChangeCallback,
    });
    var amountFormatSelector = use_amount_format_selector_1.useAmountFormatSelector({
        selectedUnit: inputUnit,
        selectedDecimalCount: inputDecimalCount,
        onFormatChanged: onFormatChanged,
        onFormatCleared: onFormatCleared,
        unitsFormat: unitsFormat,
        units: units,
    });
    return { amountInputBox: amountInputBox, amountFormatSelector: amountFormatSelector };
}
exports.useAmountPropertySelector = useAmountPropertySelector;
function getValidationMessage(propertyValueSet, value, validationFilter, filterPrettyPrint, comparer) {
    if (!value || !validationFilter) {
        return "";
    }
    if (property_1.PropertyFilter.isValid(propertyValueSet, validationFilter, comparer)) {
        return "";
    }
    else {
        return filterPrettyPrint(validationFilter);
    }
}
//# sourceMappingURL=use-amount-property-selector.js.map